import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SnapCards from "./components/SnapCards";
import Login from "./components/Login";
import ActiveTournaments from "./components/ActiveTournaments";

import GetPastDrafts from "./components/GetPastDrafts";
import SnapDraftHome from "./pages/SnapDraftHome";
import SnapDraftResults from "./pages/SnapDraftResults";
import SnapDraftRoom from "./pages/SnapDraftRoom";

import Home from "./pages/Home";
import MyRankings from "./pages/MyRankings";
import MyVariants from "./pages/MyVariants";
import MyDecks from "./pages/MyDecks";
import SnapDraftLive from "./pages/SnapDraftLive";
import SquadStrike from "./pages/SquadStrike";
import RandomMode from "./pages/RandomMode";
import Tournament from "./pages/Tournament";
import SharedDecks from "./pages/SharedDecks";
import MyDeckPositions from "./pages/MyDeckPositions";
import CardStats from "./pages/CardStats";

// Archetype Pages
import Arishem from "./pages/snapArchetypes/Arishem";
import Bounce from "./pages/snapArchetypes/Bounce";
import Clog from "./pages/snapArchetypes/Clog";
import Destroy from "./pages/snapArchetypes/Destroy";
import Discard from "./pages/snapArchetypes/Discard";
import EarlySnappers from "./pages/snapArchetypes/EarlySnappers";
import Firehair from "./pages/snapArchetypes/Firehair";
import Galactus from "./pages/snapArchetypes/Galactus";
import HighEvo from "./pages/snapArchetypes/HighEvo";
import LaneControl from "./pages/snapArchetypes/LaneControl";
import Lockdown from "./pages/snapArchetypes/Lockdown";
import Move from "./pages/snapArchetypes/Move";
import MoveBounce from "./pages/snapArchetypes/MoveBounce";
import Negative from "./pages/snapArchetypes/Negative";
import Ongoing from "./pages/snapArchetypes/Ongoing";
import OnReveal from "./pages/snapArchetypes/OnReveal";
import Power from "./pages/snapArchetypes/Power";
import Ramp from "./pages/snapArchetypes/Ramp";
import Surfer from "./pages/snapArchetypes/Surfer";
import Thanos from "./pages/snapArchetypes/Thanos";
import Ultron from "./pages/snapArchetypes/Ultron";
import Zoo from "./pages/snapArchetypes/Zoo";

function App() {
  const [user, setUser] = useState(null);

  // 🔹 Restore user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem("snapUser");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        console.error("Failed to parse stored user from localStorage");
      }
    }
  }, []);

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
    localStorage.setItem("snapUser", JSON.stringify(loggedInUser)); // persist
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("snapUser"); // clear persistence
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="app-wrapper">
        <Navbar user={user} onLogout={handleLogout} />

        <Routes>
          <Route path="/" element={<Home user={user} />} />

          {/* Draft Flow */}
          <Route path="/draft" element={<SnapDraftHome user={user} />} />
          <Route path="/draft/past" element={<GetPastDrafts />} />
          <Route path="/draft/room/:roomId" element={<SnapDraftRoom user={user} />} />
          <Route path="/draft/live/:roomId" element={<SnapDraftLive user={user} />} />
          <Route path="/draft/results/:roomId" element={<SnapDraftResults />} />

          {/* Other Pages */}
          <Route path="/cards" element={<SnapCards />} />
          <Route path="/active-tournaments/:tournamentId" element={<ActiveTournaments />} />
          <Route path="/decks" element={<MyDecks user={user} />} />
          <Route path="/deck-positions" element={<MyDeckPositions user={user} />} />
          <Route path="/variants" element={<MyVariants user={user} />} />
          <Route path="/rankings" element={<MyRankings user={user} />} />
          <Route path="/tournament" element={<Tournament user={user} />} />
          <Route path="/random-mode" element={<RandomMode />} />
          <Route path="/squad-strike" element={<SquadStrike />} />
          <Route path="/shared-decks" element={<SharedDecks user={user} />} />
          <Route path="/card-stats" element={<CardStats user={user} />} />

          {/* Archetype Routes */}
          <Route path="/archetypes/arishem" element={<Arishem />} />
          <Route path="/archetypes/bounce" element={<Bounce />} />
          <Route path="/archetypes/clog" element={<Clog />} />
          <Route path="/archetypes/destroy" element={<Destroy />} />
          <Route path="/archetypes/discard" element={<Discard />} />
          <Route path="/archetypes/earlysnappers" element={<EarlySnappers />} />
          <Route path="/archetypes/firehair" element={<Firehair />} />
          <Route path="/archetypes/galactus" element={<Galactus />} />
          <Route path="/archetypes/highevo" element={<HighEvo />} />
          <Route path="/archetypes/lanecontrol" element={<LaneControl />} />
          <Route path="/archetypes/lockdown" element={<Lockdown />} />
          <Route path="/archetypes/move" element={<Move />} />
          <Route path="/archetypes/movebounce" element={<MoveBounce />} />
          <Route path="/archetypes/negative" element={<Negative />} />
          <Route path="/archetypes/ongoing" element={<Ongoing />} />
          <Route path="/archetypes/onreveal" element={<OnReveal />} />
          <Route path="/archetypes/power" element={<Power />} />
          <Route path="/archetypes/ramp" element={<Ramp />} />
          <Route path="/archetypes/surfer" element={<Surfer />} />
          <Route path="/archetypes/thanos" element={<Thanos />} />
          <Route path="/archetypes/ultron" element={<Ultron />} />
          <Route path="/archetypes/zoo" element={<Zoo />} />

          {/* Redirect unknown routes back home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
